import { Box, Typography } from '@mui/material';

import { useAuthContext } from 'src/contexts/AuthProvider';
import useGetLedgerAccounts from 'src/features/finance/hooks/useGetLedgerAccounts';

import { Flex } from '../Flex';

type lineItem = {
    ledgerAccount?: string;
    productService?: string;
    description?: string | React.ReactNode;
    quantity: number;
    netAmount?: number;
    totalLineVat?: number;
    lineTotal?: number;
};

interface LineItemTableProps {
    columnHeaders: string[];
    data: lineItem[];
}

const LineItemTable = ({ columnHeaders, data }: LineItemTableProps) => {
    const width = `${(columnHeaders.length / 100) * 100}%`;
    const { usersCurrency } = useAuthContext();

    const { ledgerAccounts } = useGetLedgerAccounts();

    const getLedgerAccountName = (id: string) => {
        return ledgerAccounts.find(({ value }) => {
            return value === id;
        })?.label;
    };

    return (
        <Flex border="1px solid #ffea99" flexDirection="column" overflow="scroll">
            <Flex
                data-testid="column-headers"
                flex={1}
                padding="16px 8px"
                bgcolor="#FFFAE5"
                justifyContent="space-between"
            >
                {columnHeaders.map((el) => {
                    return (
                        <Box width={width} key={el} color="#1D1D1B" bgcolor="#FFFAE5">
                            {el}
                        </Box>
                    );
                })}
            </Flex>
            <div data-testid="table-data">
                {data?.map(
                    (
                        {
                            quantity,
                            description,
                            ledgerAccount,
                            lineTotal,
                            netAmount,
                            productService,
                            totalLineVat,
                        },
                        index
                    ) => {
                        return (
                            <Flex
                                bgcolor={index % 2 !== 0 ? '#FFFAE5' : 'white'}
                                key={index}
                                padding="16px 8px"
                                justifyContent="space-between"
                                flex={1}
                            >
                                <Flex width={width}>
                                    <Typography
                                        fontSize="14px"
                                        fontWeight="400"
                                        color="#1d1d1b"
                                        lineHeight="20px"
                                    >
                                        {getLedgerAccountName(ledgerAccount)}
                                    </Typography>
                                </Flex>
                                {productService && <Flex width={width}>{productService}</Flex>}
                                <Flex width={width}>{description}</Flex>
                                <Flex width={width}>{quantity}</Flex>
                                <Flex width={width}>
                                    {usersCurrency}
                                    {netAmount}
                                </Flex>
                                <Flex width={width}>
                                    {usersCurrency}
                                    {totalLineVat}
                                </Flex>
                                <Flex width={width}>
                                    {usersCurrency}
                                    {lineTotal}
                                </Flex>
                            </Flex>
                        );
                    }
                )}
            </div>
        </Flex>
    );
};
export default LineItemTable;
